import React from 'react';

import { Wrapper } from './Block.jsx';
import { EmptyPlaceholder } from '../utility/blocks';
import Name from '../utility/Name.jsx';
import TypeConfig from '../utility/TypeConfig.jsx';
import Utilities from '../utility/Utilities.jsx';

import { MessageLink } from '../../components/repositories/Type.jsx';

// #region COMPONENTS

function InventoryImageComponent(props) {
    let data = props.data || {};
    if (data.Inventory) {
        data = data.Inventory;
        if (Array.isArray(data) && data.length > 0) {
            data = data[0];
        }
    }
    const image = data.Image || data.Images && data.Images.length > 0 && data.Images[0];
    if (!image || !image.S3Id) {
        if (props.builder) {
            return <EmptyPlaceholder fullWidth={true} />
        }
        return null;
    }
    const columnWidth = props.columnWidth || 600;
    const imageSize = columnWidth * 2.0;
    let imageWidth = props.maxWidth || 600;
    let transforms = 'c_fit';
    if (props.blockConfig && props.blockConfig.block && props.blockConfig.block.isCropped) {
        transforms = `h_${imageSize},c_fill`;
    } else if (image.Height > image.Width) {
        imageWidth *= (image.Width / image.Height);
    } else {
        imageWidth -= 0.5;
    }
    const imageUrl = Utilities.imageUrl({ extension: image.Extension, id: image.S3Id }, imageSize, transforms);
    let Component = InventoryImageBlockComponent;
    if (props.inCell) {
        Component = InventoryImageCellComponent;
    }
    return <Component {...props} data={data} imageUrl={imageUrl} imageWidth={imageWidth} />
}

function InventoryImageBlockComponent(props) {
    const { contentStyle, imageStyle, isCropped, width, wrapperStyle } = Utilities.parseImageWrapperConfig(props.blockConfig, props);
    let content = (
        <img
            align="center"
            alt={props.data.Title}
            className="SharedImage"
            height={isCropped ? width : undefined}
            src={props.imageUrl}
            style={imageStyle}
            width={width} />
    );
    // if (inventoryLink && inventoryLink.length > 0) {
    //     content = (
    //         <a
    //             href={inventoryLink}
    //             style={{ display: 'block' }}
    //             target="_blank"
    //             title="">{content}</a>
    //     );
    // }
    return (
        <Wrapper {...props} className="SharedCaptionBlock" style={wrapperStyle}>
            <td
                align="center"
                className="SharedCaptionBlockInner"
                valign="top">
                <table
                    align="center"
                    border="0"
                    cellPadding="0"
                    cellSpacing="0"
                    className="SharedCaptionBottomContent"
                    style={{ minWidth: '100%' }}
                    width="100%">
                    <tbody>
                        <tr>
                            <td
                                align="center"
                                className="SharedCaptionBottomImageContent"
                                style={contentStyle}
                                valign="middle">
                                {content}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </td>
        </Wrapper>
    );
}

function InventoryImageCellComponent(props) {
    let inventoryLink;
    let width = props.maxWidth || 600;
    const containerInsideStyle = {};
    const containerOutsideStyle = { minWidth: `${width}px` };
    const imageStyle = {
        border: 0,
        height: 'auto',
        margin: 0,
        // maxHeight: `${width}px`,
        maxWidth: `${width}px`,
        msInterpolationMode: 'bicubic',
        outline: 'none',
        textDecoration: 'none',
        verticalAlign: 'bottom'
    };
    if (props.blockConfig) {
        if (props.blockConfig.block) {
            Utilities.mapStyleConfigProps(imageStyle, props.blockConfig.block, (propName, propValue) => {
                switch (propName) {
                    case 'backgroundColor':
                        containerInsideStyle.backgroundColor = propValue;
                        containerOutsideStyle.backgroundColor = propValue;
                        return true;
                    case 'isCropped':
                        return true;
                    case 'linkType':
                        switch (propValue) {
                            case MessageLink.Campaign.Custom:
                                inventoryLink = props.blockConfig.block.url;
                                break;
                            case MessageLink.Campaign.ArtsyMarketplace:
                                inventoryLink = props.data.ArtsyMarketplaceUrl;
                                break;
                            case MessageLink.Campaign.Marketplace:
                                inventoryLink = props.data.MarketplaceUrl;
                                break;
                            case MessageLink.Campaign.Website:
                                inventoryLink = props.data.WebsiteUrl;
                                break;
                        }
                        return true;
                }
            });
        }
        if (props.blockConfig.layout) {
            Utilities.mapStyleConfigProps(containerInsideStyle, props.blockConfig.layout, (propName, propValue) => {
                switch (propName) {
                    case 'paddingLeft':
                    case 'paddingRight':
                        if (propValue) {
                            width -= propValue;
                        }
                        break;
                }
            });
        }
    }
    let content = (
        <img
            alt={props.data.Title}
            className="SharedImage"
            src={props.imageUrl}
            style={imageStyle}
            width={props.imageWidth} />
    );
    if (inventoryLink && inventoryLink.length > 0) {
        content = (
            <a
                href={inventoryLink}
                style={{ display: 'block' }}
                target="_blank"
                title="">{content}</a>
        );
    }
    return (
        <table
            align="center"
            border="0"
            cellPadding="0"
            cellSpacing="0"
            className="SharedCaptionBlock"
            width={width}>
            <tbody className="SharedCaptionBlockOuter">
                <tr>
                    <td
                        align="center"
                        className="SharedCaptionBlockInner"
                        valign="top">
                        <table
                            align="center"
                            border="0"
                            cellPadding="0"
                            cellSpacing="0"
                            className="SharedCaptionBottomContent"
                            style={containerOutsideStyle}
                            width={width}>
                            <tbody style={{ backgroundColor: containerOutsideStyle.backgroundColor }}>
                                <tr>
                                    <td
                                        align="center"
                                        className="SharedCaptionBottomImageContent"
                                        height={width}
                                        style={containerInsideStyle}
                                        valign="middle">
                                        {content}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>
        </table>
    );
}

// #endregion COMPONENTS

const InventoryImageTypeConfig = {
    panel: {
        // The marketplaceName default serves the bundles without a DOM; the campaign builder passes the gated name.
        block: function ({ isArtsy, marketplaceName = 'ArtCloud Marketplace', type = Name.Content.EmailBody } = {}) {
            const group = 'block';
            const blockConfig = {
                group,
                label: 'Design',
                options: [
                    {
                        display: 'Background Color',
                        group,
                        name: 'backgroundColor',
                        type: 'color'
                    },
                    {
                        display: 'Border Radius',
                        group,
                        name: 'borderRadius',
                        options: TypeConfig.options.measurement(true),
                        type: 'measurement'
                    },
                    {
                        display: 'Border',
                        group,
                        name: 'border',
                        options: TypeConfig.options.measurement(),
                        type: 'border'
                    },
                    {
                        fullWidth: true,
                        group,
                        type: 'spacer-short'
                    },
                    {
                        display: 'Use Cropped Square Image',
                        fullWidth: true,
                        group,
                        name: 'isCropped',
                        type: 'checkbox',
                        value: false
                    }
                ]
            };
            if (type == Name.Content.EmailBody) {
                blockConfig.options.push(
                    {
                        fullWidth: true,
                        group,
                        type: 'spacer-short'
                    },
                    {
                        display: 'Inventory Link',
                        group,
                        name: 'linkType',
                        options: [
                            { display: 'No Link', value: 'none' },
                            ...MessageLink.optionsCampaign(isArtsy, marketplaceName, 'display'),
                            { display: 'Custom Link...', value: MessageLink.Campaign.Custom }
                        ],
                        type: 'dropdown',
                        value: 'none'
                    },
                    {
                        display: 'Custom Link',
                        fullWidth: true,
                        group,
                        name: 'url',
                        type: 'text',
                        visible: (config) => config.block && config.block.linkType == MessageLink.Campaign.Custom
                    }
                );
            }
            return blockConfig;
        },
        layout: function () {
            const group = 'layout';
            return {
                group,
                label: 'Layout',
                options: [
                    {
                        disabled: ['marginLeft', 'marginRight', 'marginBottom', 'marginTop'],
                        display: 'Padding/Margin',
                        group,
                        max: '100',
                        name: 'paddingMargin',
                        options: TypeConfig.options.measurement(),
                        type: 'paddingMargin',
                        value: {
                            paddingBottom: { value: '9', unit: 'px' },
                            paddingTop: { value: '9', unit: 'px' }
                        }
                    }
                ]
            };
        }
    }
}
const InventoryImageBlockTypeDefinition = (group, options) => {
    return {
        id: Name.Block.Inventory.Image,
        config: {
            block: InventoryImageTypeConfig.panel.block(options),
            layout: InventoryImageTypeConfig.panel.layout()
        },
        display: 'Inventory Image',
        group,
        image: 'inventory_image.png'
    };
}
export { InventoryImageBlockTypeDefinition, InventoryImageComponent, InventoryImageTypeConfig };
